import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';

export const Header = ({ isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Sobre Nós', path: '/sobre-nos' },
    { name: 'Serviços', path: '/servicos' },
    { name: 'Artigos e Notícias', path: '/artigos' },
    { name: 'Calculadora de Aposentadoria', path: '/calculadora' },
    { name: 'Contato', path: '/contato' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-primary/95 backdrop-blur-md shadow-lg'
          : 'bg-primary'
      }`}
    >
      <div className="container-padding mx-auto">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/logo-godoy-aguiar.png" 
              alt="Godoy & Aguiar - Sociedade de Advogados" 
              className="h-16 w-auto object-contain transition-transform group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors relative group ${
                  isActive(link.path)
                    ? 'text-accent'
                    : 'text-primary-foreground/90 hover:text-accent'
                }`}
              >
                {link.name}
                <span
                  className={`absolute -bottom-1 left-0 h-0.5 bg-accent transition-all duration-300 ${
                    isActive(link.path) ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}
                ></span>
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button
              asChild
              className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold px-6 shadow-lg hover:shadow-xl transition-all hover:scale-105"
            >
              <Link to="/contato">Fale com um Especialista</Link>
            </Button>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <Button variant="ghost" size="icon" className="text-primary-foreground">
                <i className="fas fa-bars text-xl"></i>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-primary-dark border-l-accent w-80">
              <div className="flex flex-col space-y-6 mt-8">
                <Link to="/" className="flex items-center justify-center mb-4">
                  <img 
                    src="/logo-godoy-aguiar.png" 
                    alt="Godoy & Aguiar - Sociedade de Advogados" 
                    className="h-14 w-auto object-contain"
                  />
                </Link>

                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setIsOpen(false)}
                    className={`text-lg font-medium px-4 py-3 rounded-lg transition-colors ${
                      isActive(link.path)
                        ? 'bg-accent text-accent-foreground'
                        : 'text-primary-foreground hover:bg-primary-light'
                    }`}
                  >
                    {link.name}
                  </Link>
                ))}

                <Button
                  asChild
                  className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold mt-4"
                  onClick={() => setIsOpen(false)}
                >
                  <Link to="/contato">Fale com um Especialista</Link>
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;